import { jsx as _jsx } from "react/jsx-runtime";
var EmbeddedOneTrustLink = function (props) {
    var _a, _b;
    var node = props.node;
    return (_jsx("a", { id: "ot-sdk-btn", className: "ot-sdk-show-settings", children: (_b = (_a = node === null || node === void 0 ? void 0 : node.data) === null || _a === void 0 ? void 0 : _a.target) === null || _b === void 0 ? void 0 : _b.buttonText }));
};
export default EmbeddedOneTrustLink;
